import React, { useState, Fragment } from 'react';
import styled from '@emotion/styled';
import TagsInput from 'react-tagsinput';

import Button from './Button';

const TagWrapper = styled('span')`
  display: flex;
  align-items: center;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  .tag-appearance {
    display: block;
    width: 10px;
    height: 10px;
    margin-right: 8px;
    border-radius: 50%;
    background-size: contain;
    cursor: pointer;
  }

  .fe-droplet {
    display: none;
    cursor: pointer;
    margin-right: 8px;
  }

  &:hover {
    background-color: #dad9d9;
    border-color: #dad9d9;
    .fe-droplet {
      display: block;
    }
  }
`;

const renderTag = (props, disableLastTagDeleting, valueArr, appearance, onAppearanceClick) => {
  let { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props;

  const currentAppearance = appearance && appearance.find((a) => a.value === tag);
  const tagAppearanceStyle = !currentAppearance
    ? {}
    : {
        backgroundColor:
          currentAppearance.code && !currentAppearance.imageUrl
            ? currentAppearance.code
            : 'transparent',
        backgroundImage: currentAppearance.imageUrl ? `url(${currentAppearance.imageUrl})` : 'none',
      };

  const handleAppearanceClick = () => {
    onAppearanceClick({ currentAppearance, tag });
  };

  return (
    <TagWrapper key={key} {...other}>
      {currentAppearance ? (
        <span
          className="tag-appearance"
          style={tagAppearanceStyle}
          onClick={handleAppearanceClick}
        />
      ) : (
        <i className="fe-droplet" onClick={handleAppearanceClick} />
      )}
      {getTagDisplayValue(tag)}
      {!disabled && (disableLastTagDeleting ? valueArr.length > 1 : true) ? (
        <a
          className={classNameRemove}
          data-testid={`onRemove-${key}`}
          onClick={(e) => onRemove(key)}
        />
      ) : null}
    </TagWrapper>
  );
};

const renderInput = (props) => {
  const { onChange, value, addTag, ...other } = props;
  return (
    <input
      type="text"
      onChange={onChange}
      value={value}
      style={{ fontSize: '13px', height: '31px', margin: '5px 0' }}
      {...other}
    />
  );
};

const renderLayout = (
  tagComponents,
  inputComponent,
  label,
  addTagViaButton,
  currentValue,
  valuesArray,
  showInput,
  setShowInput,
  disableTagAdding,
) => {
  return (
    <React.Fragment>
      {label ? <label>{label}</label> : null}
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {tagComponents}
        {!disableTagAdding ? (
          <Fragment>
            {valuesArray.length > 1 && !showInput ? (
              <Button
                text="+"
                onClick={() => setShowInput(true)}
                style={{ margin: '5px 0px', padding: '0px 15px' }}
              />
            ) : (
              <div className="input-group" style={{ width: '235px', margin: '0px 0' }}>
                {inputComponent}
                <div
                  className="input-group-append"
                  style={{ display: 'block !important', margin: '5px 0px', marginLeft: '-1px' }}
                >
                  <Button
                    text="Добавить"
                    disabled={!currentValue}
                    onClick={addTagViaButton}
                    style={{ padding: '1px 15px 0 15px', fontSize: '13px' }}
                  />
                </div>
              </div>
            )}
          </Fragment>
        ) : null}
      </div>
    </React.Fragment>
  );
};

const TagsInputWrapper = (props) => {
  const {
    value,
    onChange,
    label,
    placeholder = '',
    validation = () => true,
    disableLastTagDeleting = false,
    disableTagAdding = false,
    appearance,
    onAppearanceClick = () => false,
  } = props;

  const [currentValue, updateCurrentValue] = useState('');
  const [showInput, setShowInput] = useState(false);

  const addTagViaButton = () => {
    const newValue = value.slice();
    newValue.push(currentValue);
    onChange(newValue, [currentValue]);
    updateCurrentValue('');
  };

  const handleChange = (optionValues, newValues) => {
    onChange(optionValues, newValues);
    setShowInput(true);
  };

  const handleChangeInput = (value) => {
    if (validation(value)) {
      updateCurrentValue(value);
    }
  };

  return (
    <TagsInput
      className=""
      addKeys={[13]}
      onlyUnique
      inputValue={currentValue}
      removeKeys={[]}
      value={value}
      label={label}
      onChange={handleChange}
      onChangeInput={handleChangeInput}
      inputProps={{
        className: 'form-control',
        placeholder,
      }}
      renderTag={(props) =>
        renderTag(props, disableLastTagDeleting, value, appearance, onAppearanceClick)
      }
      renderInput={renderInput}
      renderLayout={(tagComponents, inputComponent) =>
        renderLayout(
          tagComponents,
          inputComponent,
          label,
          addTagViaButton,
          currentValue,
          value,
          showInput,
          setShowInput,
          disableTagAdding,
        )
      }
    />
  );
};

export default TagsInputWrapper;
